import React, { useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { gql } from '@apollo/client';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import { red, blue } from '@material-ui/core/colors';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import withStyles from "@material-ui/core/styles/withStyles";
import { BrowserRouter as Router, useHistory, useLocation } from "react-router-dom"

import Grid from "@material-ui/core/Grid/Grid";
import Alert from "@material-ui/lab/Alert/Alert";

import {useLazyQuery} from "@apollo/client/index";
import BottomAppBar from "./BottomAppBar";

import EditIcon from '@material-ui/icons/Edit';
import GetDealerInformationAction from "./Customer/GetDealerInformationAction";
import ApproveOfferAction from "./Customer/ApproveOfferAction";
import MakeAnotherOfferAction from "./Customer/MakeAnotherOfferAction";
import MakeAnotherOfferAction1 from "./Customer/MakeAnotherOfferAction1";

import DevicesIcon from '@material-ui/icons/Devices';
import Seo from "./Seo";
import MoreCars from "./MoreCars";
import Offer from "./Components/Item/Offer";
import ProvideContactInformationAction from "./Customer/ProvideContactInformationAction";
import * as ReactGA from "react-ga";
import Details from "./Components/Item/Details";
import Options from "./Components/Item/Options";

import OfferContactInformationWrapper from "./Components/Item/OfferContactInformationWrapper";
import LeftColumn from "./Components/Column/LeftColumn";
import RequestCarInformationForm from "./Components/Item/RequestCarInformationForm";
import RequestCarInformationWrapper from "./Components/Item/RequestCarInformationWrapper";

import ItemCarousel from "./Components/Item/ItemCarousel";
import FilterFormMobile from "./Components/Filter/FilterFormMobile";
import ItemHeader from "./Components/Layout/ItemHeader";
import WarmUp from "./Components/Ads/WarmUp/WarmUp";
import Support from "./Components/Support/Support";
//import DashTabs from "./Components/Dash/DashTabs";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            borderRadius: 0,
            boxShadow: 'none',
            overflow: 'visible',
            width: '100%'
        },
        wrapper: {
            width: '100%',
            display: 'flex',
            alignContent: 'flex-start',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            flex: '0 0 calc(100% - 300px)',
            ['@media (max-width:700px)']: {
                flex: '0 0 100%',
            },
            '@media print' : {
                maxWidth: 700
            }
        },
        h1: {
            fontSize: '0.875rem',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: '400',
            lineHeight: '1.43',
            letterSpacing: '0.01071em',
            margin: 0,
        },
        media: {
            height: 400,
            cursor: 'pointer',
            position: 'relative',
            width: '100%',
            [theme.breakpoints.up('xs')]: {
                height: 250,
            },
            [theme.breakpoints.up('sm')]: {
                height: 400,
            },
        },
        image: {
            width: '100%',
            marginTop: '-10%'
        },
        loading: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'absolute',
            left: '50%',
            top: 150

        },
        expand: {
            transform: 'rotate(0deg)',
            marginLeft: 'auto',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
        },
        expandOpen: {
            transform: 'rotate(180deg)',
        },
        avatar: {
            backgroundColor: blue[500],
            cursor: 'pointer'
        },
        MuiSvgIcon: {
            root: {
                marginLeft: 10
            }
        },
        chip: {
            marginRight: 4
        },
        progress: {
        },
        progressAlert: {
            marginBottom: 2
        },
        footer: {
            color: '#dfdfdf',
            position: 'absolute',
            fontSize: '0.5rem',
            marginTop: 6,
        },
        listPriceLabel: {
            textAlign: 'right',
            display: 'inline-block',
            width: 100,
            color: '#403e3e',
        },
        listPriceValue: {
            fontSize: '1rem',
            display: 'inline-block',
            marginLeft: 5,
        },
        listPriceValueOff: {
            fontSize: '1rem',
            textDecoration: 'line-through',
            display: 'inline-block',
            marginLeft: 5,
        },
        dashPriceLabel: {
            position: 'relative',
            display: 'inline-block',
            width: 100,
            color: '#403e3e',
        },
        dashPriceLabelP: {
            position: 'absolute',
            right: 0,
            bottom: -7,
        },
        dashPriceLabelI: {
            position: 'absolute',
            right: 48,
            bottom: -2,
        },
        dashPriceValue: {
            display: 'inline-block',
            fontSize: '1.5rem',
            marginLeft: 5,
        },
        youSaveRow: {
            marginTop: 10
        },
        youSaveLabel: {
            textAlign: 'right',
            display: 'inline-block',
            width: 100,
            color: '#403e3e',
        },
        youSaveValue: {
            fontSize: '1rem',
            display: 'inline-block',
            marginLeft: 5,
            color: '#c92b0f',
        },
        superior: {
            position: 'absolute',
            fontSize: '0.9rem',
            paddingLeft: 3,
            marginLeft: 5,
            color: '#403e3e',
        },
        priceBlock: {
            fontSize: '1rem',
            fontFamily: 'Arial',
            fontWeight: '400',
            lineHeight: '1.5',
            letterSpacing: '0.00938em',
        },
        chips: {
            position: 'absolute',
            top: 210,
            marginLeft: 15,
            whiteSpace: 'nowrap',
            [theme.breakpoints.up('sm')]: {
                top: 360,
            },

        },
        dashPriceRow: {
            marginTop: 5
        },
        saveLink: {
            fontSize: '1rem',
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
        },
        discountChip: {
            marginTop: 10,
            marginRight: 10
        },
        totalPriceLabel: {
            position: 'relative',
            display: 'inline-block',
            width: 100,
            color: '#403e3e',
        },
        totalPriceLabelP: {
            position: 'absolute',
            right: 18,
            bottom: -7,
        },
        totalPriceValue: {
            display: 'inline-block',
            fontSize: '1.7rem',
            marginLeft: 2,
            color: '#c92b0f',
        },
        totalSuperior: {
            position: 'absolute',
            fontSize: '1rem',
            paddingLeft: 3,
            marginLeft: 0,
        },
        totalPriceRow: {
            marginTop: 15
        },
        info: {
            marginTop: 10,
            fontSize: '0.8rem'
        },
        description: {
            paddingTop: 15,
            whiteSpace: 'pre-line',
        },
        descriptionMobile: {
            padding: '15px 10px 0 10px',
            whiteSpace: 'pre-line',
        },
        alerts: {
            marginBottom: 10
        },
        noCall: {
            margin: '0 0 20px 0',
            fontSize: '0.8rem',
            marginTop: 20,
            '@media print' : {
                display: 'none !important'
            }
        },
        noCallMobile: {
            margin: '0 0 20px 0',
            fontSize: '0.8rem',
            marginTop: 20,
            padding: '0 10px',
        },
        noCallLabel: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 0,
            fontSize: '0.8rem'
        },
        noCallText: {
            fontSize: '0.8rem',
            paddingLeft: 0,
        },
        dashIcon: {
            flex: '0 0 auto',
            display: 'inline-flex',
            color: 'rgba(0, 0, 0, 0.54)',
            fontSize: '1.5rem',
            textAlign: 'center',
            cursor: 'pointer',
            padding: 5,
            backgroundColor: '#fff',
            borderRadius: 20,
            '&:hover': {
                backgroundColor: '#ddd',
                transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
            }
        },
        offerBlock: {
            marginTop: 20,
            '@media print' : {
                display: 'none !important'
            }
        },
        offerBlockMobile: {
            marginTop: 20,
            padding: '0 10px'
        },
        searchBar: {
            width: '100%',
            paddingTop: 5,
            paddingBottom: 5,
            borderBottom: '1px dashed #3f51b4'
        },
        video: {
            marginTop: 10,
            'iframe': {
                margin: 5
            }
        },
        videoMobile: {
            marginTop: 10,
            'iframe': {
                margin: 5
            }
        }

    }
});

const GET_ITEM = gql`
  query($sn: String, $r: String) {
        getItem(sn: $sn, r: $r) {
          sn
          image
          title
          price
          dealerPrice
          off
          year
          city
          state
          mileage
          isFavorite
          description
          sold
          update
          requestCode
          appliedDiscount
          links {
            name
            value
          }
          images {
            image
            description
          }
          seo {
            title
            metaDescription
            metaKeywords
            ogTitle
            ogDescription
            ogImage
            twTitle
            twDescription
            twImage
            canonical
            eParams
          }
          shortDescription
          options {
            name
            value
          }
          details {
            name
            value
          }
          makeId
          modelId
          prevCar {
            sn
            image
            title
            price
            year
            city
            state
          }
          nextCar {
            sn
            image
            title
            price
            year
            city
            state
          }
          videoUrl
      }
  }
`;

const GET_REQUEST = gql`
  query($code: String) {
        getRequest(code: $code) {
            item {
                sn
                image
                title
                price
                dealerPrice
                off
                year
                city
                state
                mileage
                isFavorite
                description
                sold
                update
                links {
                    name
                    value
                }
                images {
                    image
                    description
                }
                shortDescription
                options {
                    name
                    value
                }
                details {
                    name
                    value
                }
                makeId
                modelId
                videoUrl
            }
            code
            status
            bookPriceMinorUnits
            extraDiscountMinorUnits
            anotherOfferAmountMinorUnits
            updateHash
            contactsProvided
        }
  }
`;

const ADD_TO_FAVORITES = gql`
  query($sn: String) {
      addToFavorites(sn: $sn) {
        message  
      }
  }
`;

const DELETE_FROM_FAVORITES = gql`
  query($sn: String) {
      deleteFromFavorites(sn: $sn) {
        message  
      }
  }
`;

let timeout;
let interval;
let lastMakeOfferSwitch = false;
let lastSn = null;

export default function Item(props) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const statusRef = useRef(null);

    const refreshInterval = 60000;
    const [discount, setDiscount] = React.useState();
    const [isBottomReached, setIsBottomReached] = React.useState(false);
    const [reviews, setReviews] = React.useState();
    const [submitReview, setSubmitReview] = React.useState();
    const [showDash, setShowDash] = React.useState(false);
    const [showFilter, setShowFilter] = React.useState();

    let [requestData, setRequestData] = React.useState();

    let [getItem, { loading, error, data, refetch }] = useLazyQuery(GET_ITEM);
    let [getRequest, { loading: reqLoading, error: reqError, data: reqData, refetch: reqRefetch }]
        = useLazyQuery(GET_REQUEST, {variables: {code: props.code}});

    let [addToFavorites, { loading: addLoading, data: addData }] = useLazyQuery( ADD_TO_FAVORITES );

    let [deleteFromFavorites, { loading: deleteLoading, data: deleteData }] = useLazyQuery( DELETE_FROM_FAVORITES );

    const isBottom = (el) => {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    };

    const trackScrolling = () => {
        const wrappedElement = document.body;
        if (isBottom(wrappedElement) && !isBottomReached) {
            document.removeEventListener('scroll', trackScrolling);
            setIsBottomReached(true);
        }
    };

    useEffect(() => {
        if (statusRef.current) {
            // console.log(statusRef);
            //scrollToRef(statusRef); //bug always scrolling
        }
        history.listen(() => {
            clearTimeout(timeout);
            clearInterval(interval);
        });

        if (item && document && document.body && window) {
            //console.log(item, document.body.clientHeight, window.innerHeight)
            if (document.body.clientHeight > window.innerHeight) {
                document.removeEventListener('scroll', trackScrolling);
                document.addEventListener('scroll', trackScrolling);
            } else {
                if (!isBottomReached) {
                    setIsBottomReached(true);
                }
            }
        }

        //if (!firstImageLoaded) {
        //setFirstImageLoaded(true);
        //}

    });

    reqData = global.getRequest ? global.getRequest : reqData;

    const exitUrl = props.returnRoute && props.returnRoute !== window.location.pathname ? props.returnRoute : null;

    const handleItemExit = () => {

        history.push(exitUrl ? exitUrl : '/');
    };

    const handleItemEdit = () => {
        history.push('/update/'+item.sn);
    };

    const handleDashClick = () => {
        setShowDash(!showDash);
    };

    const handleShowFilter = (value) => {
        if (showFilter !== value) {
            setShowFilter(value);
        }
    };

    const onRequestSent = (requestData) => {
        setRequestData(requestData);
        props.setCurrentRequestCode(requestData.code);
        history.push('/request/'+requestData.code);
        timeout = setTimeout(getRequest, refreshInterval);
    };

    const onActionComplete = () => {
        //console.log('onActionComplete');
        if(reqRefetch) {
            reqRefetch();
        }
    };

    const refetchData = () => {
        if (refetch) {
            refetch()
        } else if (reqRefetch) {
            reqRefetch();
        }
    };

    const refetchRequest = () => {
        if (reqRefetch) {
            reqRefetch();
        }
    };

    if ((!data && !reqData && !loading && !reqLoading) || (lastSn && props.sn && lastSn !== props.sn)) {
        if (props.code && !reqError) {
            getRequest();
        } else if (props.sn && !error) {
            lastSn = props.sn;
            getItem({variables: {sn: props.sn, r:Math.random().toString()}});
            ReactGA.event({
                category: 'User',
                action: 'car_view'
            });
            ReactGA.event({
                category: 'User',
                action: 'stock_' + props.sn,
                label: props.sn
            });
        }
    }

    if (reqData) {

        data = {
            getItem: reqData.getRequest.item
        };
        requestData = reqData.getRequest;

        clearTimeout(timeout);
        clearInterval(interval);
        interval = setInterval(refetchRequest, refreshInterval);

    }

    if (addData) {
        addData = null;
        deleteData = null;
        refetchData();
        props.onFavoritesChanged();
    }

    if (deleteData) {
        addData = null;
        deleteData = null;
        refetchData();
        props.onFavoritesChanged();
    }

    if (data && props.reFetchItem) {
        refetchData();
        props.onItemReFetch();
    }

    const item = data ? data.getItem : null;

    if (data && item.requestCode && !props.code) {
        history.push('/request/'+item.requestCode);
        props.setCurrentRequestCode(item.requestCode);
        return null;
    }

    const isOff = item && item.off > 0;

    //item &&  console.log(item.price, item.sn)
    const youSave = item ? ((item.dealerPrice - item.price) / 100) + discount : null;

    const onOfferChange = (value)=> {
        const newDiscount = item.price - value;
        //console.log(discount, newDiscount)
        if (discount !== newDiscount) {
            setDiscount(newDiscount/100);
        }
    };

    const eParams = item && item.seo && item.seo.eParams ? JSON.parse(item.seo.eParams) : null;
    const header = eParams && eParams.header ? eParams.header : item ? item.year + " " + item.title : '';

    const handleReviews = (data) => {
        if (!reviews) {
            setReviews(data);
        }
    };

    const isMicro = window.screen.width <= 360;
    const isMini = window.screen.width < 400;
    const isMobile = props.isMobile;

    const seoLinks = eParams && eParams.links ? eParams.links : [];

    const filter = props.filter;

    filter.addDispatchCallback('item', (newFilterOptions) => {
        history.push('/used-cars')
    });

    return (
        data ?
            <>
                {item ? <ItemHeader filter={filter} item={item} handleItemExit={handleItemExit}
                                    exitUrl={exitUrl} isMobile={props.isMobile} actions={item.update? <>
                        <div onClick={handleDashClick} className={classes.dashIcon}>⚡</div>
                        <div className={classes.dashIcon}><EditIcon onClick={handleItemEdit}/></div>
                    </> : ''}/> : null}
                {item ? <LeftColumn item={item} setReturnToItemRoute={props.setReturnToItemRoute}
                                    handleReviews={handleReviews} submitReview={submitReview} links={seoLinks.concat(item.links)}
                                    sn={item.sn} request={props.code} search={props.search} isMobile={isMobile}
                                    hasFilter={true} filter={props.filter}
                /> : null}
                <div className={classes.wrapper} id="itemWrapper">
                    {isMobile ? <div className={classes.searchBar}>
                        <FilterFormMobile isMobile={true} filter={filter} handleShowFilter={handleShowFilter}/></div>
                        : null}

                    {showFilter ? null : <>
                        <Card className={classes.root}>
                            <Seo seo={item.seo}/>
                            {/*<CardHeader
                                avatar={
                                    <Avatar aria-label="recipe" className={classes.avatar} onClick={() => handleItemExit()}>
                                        <BackIcon/>
                                    </Avatar>
                                }
                                action={<>
                                    {1 || item.update?
                                        <>
                                            <div onClick={handleDashClick} className={classes.dashIcon}>⚡</div>
                                            <div className={classes.dashIcon}><EditIcon onClick={handleItemEdit}/></div>
                                        </> : ''}
                                </>
                                }
                                title={<h1 className={classes.h1}>{header}</h1>}
                                subheader={header.indexOf(item.city) === -1 ? item.city + ", " + item.state : null}
                            />*/}


                            <div className={classes.carousel}>
                                <ItemCarousel item={item} header={header} isMobile={isMobile} isMicro={isMicro}
                                              isMini={isMini} size={props.size} screenWidth={props.screenWidth}/>
                            </div>
                            {showDash && props.dashTabs ? props.dashTabs({item:item, isMobile:isMobile}) :
                                <>
                                    {item.sold ? '' :
                                        <div className={isMobile ? classes.offerBlockMobile : classes.offerBlock}>

                                            <Grid className={classes.priceBlock}>

                                                {requestData ? <div className={classes.alerts}>
                                                        <Alert className={classes.progressAlert} severity="success">Success! Your request is being
                                                            processed. Request code: <b>{requestData.code}</b>.</Alert>

                                                        {requestData.status === 10 ?
                                                            <><Alert className={classes.progressAlert} severity="success">
                                                                Your offer <b>${
                                                                new Intl.NumberFormat().format((requestData.bookPriceMinorUnits - requestData.extraDiscountMinorUnits) / 100)
                                                            }</b> is approved! Please contact Dealer to finalize the purchase.
                                                            </Alert><GetDealerInformationAction request={requestData}/></> :
                                                            requestData.status === 20 ?
                                                                <><Alert className={classes.progressAlert} severity="success">
                                                                    Congratulations! Dealer has approved Booking Price: <b>${
                                                                    new Intl.NumberFormat().format(requestData.bookPriceMinorUnits / 100)
                                                                }</b>. Please contact Dealer to finalize the purchase.
                                                                </Alert><GetDealerInformationAction request={requestData}/></> :
                                                                requestData.status === 70 ?
                                                                    <><Alert className={classes.progressAlert} severity="success">
                                                                        Approved Dealer Offer: <b>${
                                                                        new Intl.NumberFormat().format(requestData.anotherOfferAmountMinorUnits / 100)
                                                                    }</b>. Please contact Dealer to finalize the purchase.
                                                                    </Alert>
                                                                        <GetDealerInformationAction request={requestData}/></> :
                                                                    requestData.status === 30 ?
                                                                        <><Alert className={classes.progressAlert} severity="info">
                                                                            Dealer made you an offer: <b>${
                                                                            new Intl.NumberFormat().format(requestData.anotherOfferAmountMinorUnits / 100)
                                                                        }</b>. What would you like to do?
                                                                        </Alert><ApproveOfferAction request={requestData} onActionComplete={onActionComplete}/>
                                                                            {lastMakeOfferSwitch = !lastMakeOfferSwitch}
                                                                            {lastMakeOfferSwitch ? <MakeAnotherOfferAction request={requestData} onActionComplete={onActionComplete}/>
                                                                                : <MakeAnotherOfferAction1 request={requestData} onActionComplete={onActionComplete}/>}
                                                                        </> :
                                                                        requestData.status === 50 ?
                                                                            <><Alert className={classes.progressAlert} severity="info">
                                                                                Dealer is not ready for your offer. Would you like to make another one?
                                                                            </Alert>
                                                                                {lastMakeOfferSwitch = !lastMakeOfferSwitch}
                                                                                {lastMakeOfferSwitch ? <MakeAnotherOfferAction request={requestData} onActionComplete={onActionComplete}/>
                                                                                    : <MakeAnotherOfferAction1 request={requestData} onActionComplete={onActionComplete}/>}
                                                                            </> :
                                                                            requestData.status === 90 ?
                                                                                <><Alert className={classes.progressAlert} severity="info">
                                                                                    Dealer requested your contact information. Would you like to provide it?
                                                                                </Alert><ProvideContactInformationAction request={requestData} onActionComplete={onActionComplete}/>
                                                                                </> :
                                                                                requestData.status === 100 ?
                                                                                    <><Alert className={classes.progressAlert} severity="info" icon={<CircularProgress size={20}
                                                                                                                                                                       disableShrink
                                                                                                                                                                       ref={statusRef}
                                                                                                                                                                       className={classes.progress}/>}>
                                                                                        Contact Information has been sent to Dealer. Please wait...
                                                                                    </Alert>
                                                                                    </> :
                                                                                    requestData.status === 80 ?
                                                                                        <><Alert className={classes.progressAlert} severity="info"
                                                                                                 icon={<CircularProgress size={20}
                                                                                                                         disableShrink
                                                                                                                         ref={statusRef}
                                                                                                                         className={classes.progress}/>}>
                                                                                            Your Offer: <b>${
                                                                                            new Intl.NumberFormat().format((requestData.bookPriceMinorUnits - requestData.extraDiscountMinorUnits) / 100)
                                                                                        }</b> is received. Please hold. Status will update real-time.
                                                                                        </Alert>
                                                                                            <ApproveOfferAction request={requestData} onActionComplete={onActionComplete}/>
                                                                                            {lastMakeOfferSwitch = !lastMakeOfferSwitch}
                                                                                            {lastMakeOfferSwitch ? <MakeAnotherOfferAction request={requestData} onActionComplete={onActionComplete}/>
                                                                                                : <MakeAnotherOfferAction1 request={requestData} onActionComplete={onActionComplete}/>}
                                                                                        </> :
                                                                                        <Alert className={classes.progressAlert} severity="info"
                                                                                               icon={<CircularProgress size={20}
                                                                                                                       disableShrink
                                                                                                                       ref={statusRef}
                                                                                                                       className={classes.progress}/>}>
                                                                                            Your Offer <b>${
                                                                                            new Intl.NumberFormat().format((requestData.bookPriceMinorUnits - requestData.extraDiscountMinorUnits) / 100)
                                                                                        }</b> has been <b>received</b>. Status will update real-time. Please wait...
                                                                                        </Alert>
                                                        }
                                                        {<OfferContactInformationWrapper onActionComplete={onActionComplete} request={requestData}/>}
                                                    </div>
                                                    :

                                                    <>
                                                        {/*<Offer item={item} youSave={youSave} isMobile={isMobile} isMicro={isMicro} isMini={isMini}
                                                               onOfferChange={onOfferChange}
                                                               onRequestSent={onRequestSent}
                                                               nextCar={item.nextCar}
                                                               handleClick={props.handleClick}
                                                               returnRoute={window.location.pathname}
                                                        />*/}
                                                        <RequestCarInformationWrapper item={item} youSave={youSave} isMobile={isMobile} isMicro={isMicro} isMini={isMini}
                                                                                      onOfferChange={onOfferChange}
                                                                                      onRequestSent={onRequestSent}
                                                                                      nextCar={item.nextCar}
                                                                                      handleClick={props.handleClick}
                                                                                      returnRoute={window.location.pathname}
                                                                                      refetch={refetch}
                                                                                      size={props.size}
                                                        />
                                                    </>
                                                }
                                            </Grid>
                                        </div>
                                    }

                                    {item.sold ? <p></p> : ''}
                                    <div className={isMobile ? classes.descriptionMobile : classes.description}>
                                        {item.description || item.shortDescription || item.details || item.options ?
                                            <Typography>
                                                {item.shortDescription}{item.description}
                                                <div className={isMobile ? classes.videoMobile : classes.video}>
                                                    {item.videoUrl ?
                                                        item.videoUrl.split('\n').map((video, i) => <iframe width="420" height="345" frameBorder="0" src={video}>
                                                        </iframe>)

                                                        : ''}
                                                </div>
                                                {item.details && item.details.length ? <Details item={item} isMobile={isMobile}/> : ''}
                                                {item.options && item.options.length ? <Options item={item} isMobile={isMobile} isPreview={true}/> : ''}
                                            </Typography>
                                            : <Typography>No description provided</Typography>}
                                    </div>
                                    {props.isMobile ?
                                        <Support isMobile={props.isMobile} screenWidth={props.screenWidth} item={item}/>
                                        : null}
                                    <WarmUp isMobile={props.isMobile} screenWidth={props.screenWidth}/>
                                </>}
                        </Card>
                        {isBottomReached ? <MoreCars
                            handleClick={props.handleClick}
                            sn={props.sn}
                            exclude={[props.sn]}
                            returnRoute={location.pathname}
                            title={isMobile ? 'Similar cars' : ''}
                            otherCarsTitle={'More cars'}
                            yearCount={0}
                            limit={props.size === 'xxxl' ? 3 : 2}
                            search={item ? item.sn : '~'} //anticache
                            scrollingAutoload={false}
                            listKey={1}
                            size={props.size}
                            isMobile={props.isMobile}
                        />: null}

                    </>}
                 </div>
            </> : <>
                {/*<div className={classes.loading}>
                    <CircularProgress disableShrink className={classes.progress} size={20}/>
                </div>
                <BottomAppBar/>*/}
            </>


    );
}
